<template>
  <div class="d-flex">
    <!-- More Actions -->
    <v-menu
      v-if="moreActions.length"
      tile
      left
      offset-y
      allow-overflow
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          data-cy="table-three-dot-actions"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>$snMenuDotsHorizontalSolid</v-icon>
        </v-btn>
      </template>
      <v-list data-cy="table-three-dot-actions-dropdown">
        <v-list-item
          v-for="(action, index) in moreActions"
          :key="index"
          :data-cy="`table-three-dot-action-${action.emit}`"
          link
          @click="$emit(action.emit)"
        >
          <v-list-item-icon v-if="action.icon">
            <v-icon>{{ action.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>
            {{ action.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Secondary Action -->
    <sn-btn
      v-if="secondaryAction"
      type="secondary"
      size="standard"
      class="ml-3"
      data-cy="table-secondary-action-btn"
      :prepend-icon="secondaryAction.icon"
      :text="secondaryAction.text"
      :data-pendo="pendo"
      :loading="secondaryAction.loading"
      :dropdown="secondaryAction.dropdown"
      :dropdown-options="secondaryAction.dropdownOptions"
      :text-case="secondaryAction.textCase"
      @click="handleSecondaryAction"
    />

    <!-- Primary Action -->
    <sn-btn
      v-if="primaryAction"
      type="primary"
      size="standard"
      class="ml-3"
      data-cy="table-primary-action-btn"
      :prepend-icon="primaryAction.icon"
      :text="primaryAction.text"
      :data-pendo="pendo"
      :loading="primaryAction.loading"
      :dropdown="primaryAction.dropdown"
      :dropdown-options="primaryAction.dropdownOptions"
      :text-case="primaryAction.textCase"
      @click="handlePrimaryAction"
    />
  </div>
</template>

<script>
import SnBtn from '~/components/snui/v2/snBtn/snBtn'

export default {
  name: 'SnTablePluginTableActions',
  components: {
    SnBtn
  },
  props: {
    actions: {
      type: Array,
      required: true
    },
    pendo: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    primaryAction () {
      return this.actions.find(a => a.type === 'primary')
    },
    secondaryAction () {
      return this.actions.find(a => a.type === 'secondary')
    },
    moreActions () {
      return this.actions.filter(a => {
        const noType = !a.type
        const typeIsNotPrimary = a.type !== 'primary'
        const typeIsNotSecondary = a.type !== 'secondary'
        const actionIsNotPrimaryOrSecondary = typeIsNotPrimary && typeIsNotSecondary

        return noType || actionIsNotPrimaryOrSecondary
      })
    }
  },
  methods: {
    handleSecondaryAction (val) {
      this.$emit(this.secondaryAction.emit, val)
    },
    handlePrimaryAction (val) {
      if (this.primaryAction.dropdown) {
        this.$emit(this.primaryAction.emit, val)
      } else {
        this.$emit(this.primaryAction.emit)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
